import { NgStyle } from '@angular/common';
import { Component, input, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';

/**
 * Ícone genérico.
 *
 * Renderiza um ícone de fonte (ex.: Font Awesome via {@link fontIcon}) ou uma
 * imagem de fundo (via {@link imageIcon}). As classes utilitárias de ícone do
 * design system (`.ai-icon-*`, globais) podem ser passadas em {@link styleClass}
 * — continuam válidas por serem regras globais aplicadas ao `<i>` interno.
 *
 * Estilos encapsulados (`ViewEncapsulation.Emulated`): a regra base `.ai-icon`
 * estiliza o `<i>` do próprio template.
 */
@Component({
    selector: 'ai-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgStyle],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Icon {
    /** Classe do ícone de fonte (ex.: `fa-solid fa-trash`). */
    readonly fontIcon = input<string | undefined | null>();

    /** URL da imagem usada como `background-image` do ícone. */
    readonly imageIcon = input<string | undefined | null>();

    /** Estilos inline aplicados ao ícone. */
    readonly style = input<any>({});

    /** Classe CSS extra aplicada ao ícone. */
    readonly styleClass = input<string | undefined | null>();
}
